import { message } from 'ant-design-vue/es'
// import defaultSettings from '../defaultSettings';

let lessNodesAppended

const colorList = [
  {
    key: '薄暮', color: '#F5222D'
  },
  {
    key: '火山', color: '#FA541C'
  },
  {
    key: '日暮', color: '#FAAD14'
  },
  {
    key: '明青', color: '#13C2C2'
  },
  {
    key: '极光绿', color: '#52C41A'
  },
  {
    key: '拂晓蓝（默认）', color: '#1890FF'
  },
  {
    key: '极客蓝', color: '#2F54EB'
  },
  {
    key: '酱紫', color: '#722ED1'
  }
]

const updateTheme = primaryColor => {
  // Don't compile less in production!
  /* if (process.env.NODE_ENV === 'production') {
    return;
  } */
  // Determine if the component is remounted
  if (!primaryColor) {
    return
  }
  const hideMessage = message.loading('正在编译主题！', 0)
  function buildIt () {
    if (!window.less) {
      // 脚本说它加载完了却东西没挂上来，也不能把人晾在「正在编译」上
      message.error('主题编译失败：less.js 未就绪，刷新后重试')
      hideMessage()
      return
    }
    setTimeout(() => {
      window.less
        .modifyVars({
          '@primary-color': primaryColor
        })
        .then(() => {
          hideMessage()
        })
        .catch((err) => {
          // less.js 本身跑起来了，但 color.less 编译不下来：
          // 把真正的报错带进消息，不然只剩下「Failed to update theme」一句话
          message.error(`主题编译失败：${(err && (err.message || err.type)) || '未知原因'}，刷新后重试`)
          hideMessage()
        })
    }, 200)
  }
  if (!lessNodesAppended) {
    // insert less.js and color.less
    const lessStyleNode = document.createElement('link')
    const lessConfigNode = document.createElement('script')
    const lessScriptNode = document.createElement('script')
    lessStyleNode.setAttribute('rel', 'stylesheet/less')
    lessStyleNode.setAttribute('href', '/color.less')
    lessConfigNode.innerHTML = `
      window.less = {
        async: true,
        env: 'production',
        javascriptEnabled: true
      };
    `
    lessScriptNode.src = 'https://gw.alipayobjects.com/os/lib/less.js/3.8.1/less.min.js'
    lessScriptNode.async = true
    lessScriptNode.onload = () => {
      window.clearTimeout(giveUp)
      buildIt()
      lessScriptNode.onload = null
    }
    lessScriptNode.onerror = () => {
      window.clearTimeout(giveUp)
      message.error('主题编译失败：拉不到 less.js（网络不通或被拦），刷新后重试')
      hideMessage()
    }
    /* 请求挂起时 onload / onerror 都永远不会来，不能让「正在编译主题」一直转；
       到了点就收场，并告诉人卡在哪 */
    const giveUp = window.setTimeout(() => {
      message.error('主题编译失败：拉取 less.js 超时，检查网络后重试')
      hideMessage()
    }, 15000)
    document.body.appendChild(lessStyleNode)
    document.body.appendChild(lessConfigNode)
    document.body.appendChild(lessScriptNode)
    lessNodesAppended = true
  } else {
    buildIt()
  }
}

const updateColorWeak = colorWeak => {
  // document.body.className = colorWeak ? 'colorWeak' : '';
  colorWeak ? document.body.classList.add('colorWeak') : document.body.classList.remove('colorWeak')
}

export { updateTheme, colorList, updateColorWeak }
